<ui-assignee-avatar class="avatar" [uiAssignee]="notification.notificationData.actor | asAssignee" uiSize="sm"></ui-assignee-avatar>
<div class="title">{{ title }}</div>
<div class="date">{{ notification.createdAt | date : "dd MMM, yyyy" }}</div>
<div class="summary">
  <div class="message-icon" *ngIf="notification.notificationData.item.targetType === 'metric_snapshot'">
    <i class="fs-20px" [uiTooltipTitle]="'metric' | localize" ui-icon ui-tooltip uiTheme="fill" uiType="metric"></i>
  </div>
  <div class="message-icon" *ngIf="notification.notificationData.item.targetType !== 'metric_snapshot' && notification.notificationData.item.targetType !== 'checkin'">
    <i class="fs-20px" [uiType]="notification.notificationData.item.targetType" [uiTooltipTitle]="notification.notificationData.item.targetType | localize" ui-icon ui-tooltip uiTheme="fill"></i>
  </div>
  <span class="item">{{ notification.notificationData.item.targetTitle }}</span>
</div>
<div class="full">
  <div class="inbox-box">
    <div class="inbox-section">
      <div class="heading">{{ "the_update" | localize }}:</div>
      <div *ngIf="notification.notificationData.item.targetType !== 'comment'">
        <div class="list-item">{{ "new_value" | localize }}</div>
        <span *ngIf="notification.notificationData.item.targetItem.targetInfo.manualType === 'boolean'"
          >: {{ notification.notificationData.item.targetItem.updatedValue.target | metricValue : notification.notificationData.item.targetItem.updatedValue.format }}</span
        >
        <span *ngIf="notification.notificationData.item.targetItem.targetInfo.manualType !== 'boolean'"
          >: {{ notification.notificationData.item.targetItem.updatedValue.target | metricValue : notification.notificationData.item.targetItem.updatedValue.format }} (
          <div class="list-item">{{ "target" | localize }}</div>
          :&nbsp;<span *ngIf="notification.notificationData.item.targetItem.targetOperator === 'should_stay_above'"
            >{{ "should_stay_above_target_item_target_info_value" | localize }}
            {{ notification.notificationData.item.targetItem.targetInfo.target | metricValue : notification.notificationData.item.targetItem.targetInfo.format
            }}<span *ngIf="notification.notificationData.item.targetItem.targetInfo.critical"
              >{{ "and_absolutely_must_be_above_target_item_critical_value" | localize }}
              {{ notification.notificationData.item.targetItem.targetInfo.critical | metricValue : notification.notificationData.item.targetItem.targetInfo.format }}</span
            ></span
          ><span *ngIf="notification.notificationData.item.targetItem.targetOperator === 'should_stay_below'"
            >{{ "should_stay_below_target_item_target_info_value" | localize }}
            {{ notification.notificationData.item.targetItem.targetInfo.target | metricValue : notification.notificationData.item.targetItem.targetInfo.format
            }}<span *ngIf="notification.notificationData.item.targetItem.targetInfo.critical"
              >{{ "and_absolutely_must_be_below_target_item_critical_value" | localize }}
              {{ notification.notificationData.item.targetItem.targetInfo.critical | metricValue : notification.notificationData.item.targetItem.targetInfo.format }}</span
            ></span
          ><span *ngIf="notification.notificationData.item.targetItem.targetOperator === 'at_least'"
            >{{ "should_increase_to_target_item_target_info_value" | localize }}
            {{ notification.notificationData.item.targetItem.targetInfo.target | metricValue : notification.notificationData.item.targetItem.targetInfo.format
            }}<span *ngIf="notification.notificationData.item.targetItem.targetInfo.critical"
              >{{ "and_absolutely_must_be_above_target_item_critical_value" | localize }}
              {{ notification.notificationData.item.targetItem.targetInfo.critical | metricValue : notification.notificationData.item.targetItem.targetInfo.format }}</span
            ></span
          ><span *ngIf="notification.notificationData.item.targetItem.targetOperator === 'at_most'"
            >{{ "should_decrease_to_target_item_target_info_value" | localize }}
            {{ notification.notificationData.item.targetItem.targetInfo.target | metricValue : notification.notificationData.item.targetItem.targetInfo.format
            }}<span *ngIf="notification.notificationData.item.targetItem.targetInfo.critical"
              >{{ "and_absolutely_must_be_below_target_item_critical_value" | localize }}
              {{ notification.notificationData.item.targetItem.targetInfo.critical | metricValue : notification.notificationData.item.targetItem.targetInfo.format }}</span
            ></span
          >)</span
        >
      </div>
      <div>
        <div class="list-item">
          {{ "note" | localize }}
          <span *ngIf="notification.notificationData.item.targetType !== 'comment'">: <rich-text-viewer [text]="notification.notificationData.item.targetItem.updateNote"></rich-text-viewer></span>
          <span *ngIf="notification.notificationData.item.targetType === 'comment'">: <rich-text-viewer [text]="notification.notificationData.item.content"></rich-text-viewer></span>
        </div>
      </div>
    </div>
    <div class="inbox-section with-reactions">
      <a class="link classic" [attr.href]="notification.notificationData.item.url">{{ "view_update" | localize }}</a>
      <div class="reacted-with">
        <span>{{ notification.notificationData.item.reactions[0].emoji }}</span>
        <span *ngIf="notification.notificationData.item.reactions.length > 1">{{ notification.notificationData.item.reactions[1].emoji }}</span>
        <span *ngIf="notification.notificationData.item.reactions.length > 2">{{ notification.notificationData.item.reactions[2].emoji }}</span>
        <span *ngIf="notification.notificationData.item.reactions.length > 3">...</span>
      </div>
    </div>
  </div>
</div>
